import { typography } from 'styles/typography'

const themeStyles = colors => {
  const defaultStyles = {
    container: {
      width: '100%',
      border: 'none',
      padding: '30px 0em',
      paddingTop: 30,
      backgroundColor: colors.primary,
      userSelect: 'none'
    },
    mainTitle: {
      ...typography.font,
      fontSize: '2.1rem',
      color: colors.white,
      fontWeight: 700
    },
    label: {
      ...typography.font,
      fontSize: 18,
      color: colors.white
    },
    marginRight: {
      marginRight: '25px'
    },
    patientSwitchButton: {
      backgroundColor: colors.white,
      color: colors.primary,
      borderRadius: 20,
      border: 'none',
      padding: '10px',
      fontSize: 14,
      fontWeight: 700,
      marginRight: 10,
      cursor: 'pointer',
      marginLeft: 0
    }
  }
  return defaultStyles
}

export default themeStyles
